import axios from 'axios';
import { Component } from 'react';

class ApiMaster extends Component {
  static getEntity = async () => {
    const result = await axios({
      url: `dga-user-service-master/entity`,
      method: 'get',
    });
    return result;
  };

  static lawGroup = async () => {
    const result = await axios({
      url: `dga-user-service-master/law_group`,
      method: 'get',
    });
    return result;
  };

  static masterLogin = async () => {
    const result = await axios({
      url: `dga-user-service-master/masterLogin`,
      method: 'get',
    });
    return result;
  };

  static homeFilter = async () => {
    const result = await axios({
      url: `dga-user-service-master/homeFilter`,
      method: 'get',
    });
    return result;
  };

  static banner = async () => {
    const result = await axios({
      url: `dga-user-service-master/banner`,
      method: 'get',
    });
    return result;
  };

  static landingPage = async () => {
    const result = await axios({
      url: `dga-user-service-master/landingPage`,
      method: 'get',
    });
    return result;
  };

  static law_list = async () => {
    const result = await axios({
      url: `dga-user-service-master/law_list`,
      method: 'get',
    });
    return result;
  };

  static law_evaluate = async (search) => {
    const result = await axios({
      url: `dga-user-service-master/law_evaluate`,
      method: 'post',
      data: search
    });
    return result;
  };
}

export default ApiMaster;
